<h1 mat-mdc-dialog-title>Register Tire Change Transaction</h1>

<div class="turboContainer" style="width:600px;">
  <h2>Trailer</h2>
  <div class="row" style="margin-bottom:20px;">
    <div class="col-5">
      <mat-form-field appearance="outline">
        <mat-label>Select Trailer</mat-label>
        <input type="text" matInput [formControl]="trailerControl" [matAutocomplete]="trailerAuto">
        <mat-progress-spinner *ngIf="loading" matSuffix mode="indeterminate" diameter="20" strokeWidth="3" style="margin-right: 8px;"></mat-progress-spinner>
        <button *ngIf="trailerControl.value" mat-icon-button matSuffix aria-label="Clear" (click)="trailerControl.setValue(null)">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #trailerAuto="matAutocomplete" [displayWith]="displayTrailer">
          <mat-option *ngFor="let trailer of filteredTrailers | async" [value]="trailer">
            {{ trailer.Alias }} – {{ trailer.Title}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <h2>Credit</h2>
  <div class="row" style="margin-bottom:20px;">
    <div class="col-7">
      <mat-form-field appearance="outline">
        <mat-label>Performed Tire Change</mat-label>
        <input type="text" matInput [formControl]="locationControl" [matAutocomplete]="creditAuto">
        <mat-progress-spinner *ngIf="loading" matSuffix mode="indeterminate" diameter="20" strokeWidth="3" style="margin-right: 8px;"></mat-progress-spinner>
        <button *ngIf="locationControl.value && !loading" mat-icon-button matSuffix aria-label="Clear" (click)="clearLocationSelection('credit')">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #creditAuto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let location of creditFilteredLocations | async" [value]="location">
            {{location.LocationCode}} - {{ location.Name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field appearance="outline">
        <mat-label>Amount (kr)</mat-label>
        <input matInput type="number" [formControl]="creditAmountControl">
        <mat-icon matSuffix matTooltip="The amount credited to the station that provided the tire change." matTooltipPosition="above">help</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <h2>Debit</h2>
  <div class="row" style="margin-bottom:20px;">
    <div class="col-7">
      <mat-form-field appearance="outline">
        <mat-label>Originally Responsible Station</mat-label>
        <input type="text" matInput [formControl]="debitLocationControl" [matAutocomplete]="debitAuto">
        <mat-progress-spinner *ngIf="loading" matSuffix mode="indeterminate" diameter="20" strokeWidth="3" style="margin-right: 8px;"></mat-progress-spinner>
        <button *ngIf="debitLocationControl.value && !loading" mat-icon-button matSuffix aria-label="Clear" (click)="clearLocationSelection('debit')">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #debitAuto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let location of debitFilteredLocations | async" [value]="location">
            {{location.LocationCode}} - {{ location.Name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field appearance="outline">
        <mat-label>Amount (kr)</mat-label>
        <input matInput type="number" [formControl]="debitAmountControl">
        <mat-icon matSuffix matTooltip="The amount debited from the location that was originally assigned to perform the tire change." matTooltipPosition="above">help</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <mat-dialog-actions style="justify-content:right;">
    <button mat-raised-button color="primary" (click)="registerTransaction()" [disabled]="isConfirmDisabled">Confirm Transaction</button>
  </mat-dialog-actions>
</div>
